<template>
    <div>
        <div class="w main">
            <h3 class="title" style="text-align:center">{{ list[listIndex].name }}</h3>
            <div class="lineBack">
                <img @click="$router.back()" style="margin-left: auto;width: 30px;display: block" src="../../public/img/classify/back.svg" alt="">
            </div>
            <div class="container flex">
                <div
                        class="product-card"
                        v-for="(item,index) in list[listIndex].count"
                        :key="index"
                >
                    <img @click="showBigImg(index)" :src="getUrl(index)" alt="" />
<!--                    <div class="productTitle">{{ item.title }}</div>-->
                </div>
            </div>
        </div>
        <dialog_product_detail :dialogVisible.sync="dialogVisible" :info="info" class-name="img" />
    </div>
</template>

<script>
import dialog_product_detail from '@/components/dialog_product_detail.vue'
import { classifyList } from '@/constants/classify'
export default {
    name: 'ProductDisplay',
    components: { dialog_product_detail },
    data() {
        return {
            list: classifyList,
            dialogVisible: false,
            info: {},
            listIndex: 0,
        }
    },
    activated() {
        this.listIndex = this.$route.params.index || 0
    },
    methods: {
        showBigImg(index) {
            this.info = {
                imgUrl: this.getUrl(index)
            }
            this.dialogVisible = true
        },
        getUrl(index) {
            return require(`/public/img/classify/${Number(this.listIndex)+1}/${index+1}.jpg`)
        }
        // toDetails(item) {
        //     this.info = item
        //     this.dialogVisible = true
        // },
    },
}
</script>

<style lang="scss" scoped>
.lineBack {

}
.main {
  margin-bottom: 50px;
}
.container {
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  font-size: 0px;
}
.product-card {
  margin-bottom: 40px;
  cursor: pointer;
    img {
        width: 336px;
        height: 336px;
    }
  &:hover {
    transition: all 0.5s;
    transform: scale(1.1);
    box-shadow: 0 0 10px var(--box-shadow);
    .productTitle {
      background-color: var(--font-color);
      color: #fff;
    }
  }
}
.productTitle {
  height: 45px;
  line-height: 45px;
  border: 1px solid var(--bg-color);
  text-align: center;
  font-size: 18px;
}
.el-dialog {
  border-radius: 30px;
}
</style>
